// <s-idle-offer> — shows a dismissible offer after the visitor has spent 15 minutes
// on the shop in this browser session (time is summed across page views).
// Shows at most once per browser; dismissal is remembered in localStorage.
class SIdleOffer extends HTMLElement {
  #ac = null;
  #timer = 0;
  #tick = 0;
  static TIME_KEY = "tc-session-ms";
  static SEEN_KEY = "tc-idle-offer-seen";

  connectedCallback() {
    if (this.#read(localStorage, SIdleOffer.SEEN_KEY)) return;
    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    const limit = Number(this.dataset.delayMinutes || 15) * 60000;
    this.querySelectorAll("[data-idle-close]").forEach((btn) =>
      btn.addEventListener("click", () => this.#close(), { signal })
    );
    this.addEventListener("keydown", (e) => { if (e.key === "Escape") this.#close(); }, { signal });
    this.querySelector("[data-idle-copy]")?.addEventListener("click", (e) => this.#copy(e.currentTarget), { signal });

    let spent = Number(this.#read(sessionStorage, SIdleOffer.TIME_KEY) || 0);
    let last = Date.now();
    this.#tick = window.setInterval(() => {
      const now = Date.now();
      if (document.visibilityState === "visible") spent += now - last;
      last = now;
      this.#write(sessionStorage, SIdleOffer.TIME_KEY, String(spent));
      if (spent >= limit) this.#open();
    }, 5000);
    document.addEventListener("visibilitychange", () => { last = Date.now(); }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    window.clearInterval(this.#tick);
    window.clearTimeout(this.#timer);
  }

  #open() {
    window.clearInterval(this.#tick);
    this.#write(localStorage, SIdleOffer.SEEN_KEY, "1");
    const panel = this.querySelector("[data-idle-panel]");
    if (!panel) return;
    panel.hidden = false;
    this.#timer = window.setTimeout(() => panel.querySelector("[data-idle-close]")?.focus({ preventScroll: true }), 50);
  }

  #close() {
    const panel = this.querySelector("[data-idle-panel]");
    if (panel) panel.hidden = true;
    this.#write(localStorage, SIdleOffer.SEEN_KEY, "1");
  }

  async #copy(button) {
    const code = button.dataset.code || "";
    try {
      await navigator.clipboard.writeText(code);
      const done = button.dataset.copiedLabel;
      if (done) button.textContent = done;
    } catch (_) { /* clipboard unavailable: the code stays visible to type */ }
  }

  #read(store, key) { try { return store.getItem(key); } catch (_) { return null; } }
  #write(store, key, value) { try { store.setItem(key, value); } catch (_) { /* storage blocked */ } }
}

if (!customElements.get("s-idle-offer")) customElements.define("s-idle-offer", SIdleOffer);
